import { Navigate } from 'react-router'

import { withNamespaces } from '@/i18n/route-namespaces'

export const bubbleRoutes = {
  path: 'agentik',
  children: [
    {
      index: true,
      element: <Navigate to="agents" />,
    },
    {
      path: 'agents',
      lazy: withNamespaces(['bubble'], async () => {
        const { BubbleAgents } = await import('@/pages/bubble/agents')

        return { Component: BubbleAgents }
      }),
      children: [
        {
          index: true,
          element: <Navigate to="list" />,
        },
        {
          path: 'list',
          lazy: withNamespaces(['bubble'], async () => {
            const { BubbleList } = await import('@/pages/bubble/agents/list')

            return { Component: BubbleList }
          }),
        },
        {
          path: 'create',
          lazy: withNamespaces(['bubble'], async () => {
            const { BubbleAgentCreate } = await import(
              '@/pages/bubble/agents/edit/create'
            )

            return { Component: BubbleAgentCreate }
          }),
        },
        {
          path: ':bubbleId/edit',
          lazy: withNamespaces(['bubble'], async () => {
            const { BubbleAgentEdit } = await import(
              '@/pages/bubble/agents/edit/edit'
            )

            return { Component: BubbleAgentEdit }
          }),
        },
      ],
    },
    {
      path: 'tools',
      lazy: withNamespaces(['bubble'], async () => {
        const { BubbleTasks } = await import('@/pages/bubble/tasks')

        return { Component: BubbleTasks }
      }),
      children: [
        {
          index: true,
          element: <Navigate to="list" />,
        },
        {
          path: 'list',
          lazy: withNamespaces(['bubble'], async () => {
            const { TaskList } = await import('@/pages/bubble/tasks/list')

            return { Component: TaskList }
          }),
        },
        {
          path: 'create',
          lazy: withNamespaces(['bubble'], async () => {
            const { TaskEdit } = await import('@/pages/bubble/tasks/edit')

            return { Component: TaskEdit }
          }),
        },
        {
          path: ':taskId/edit',
          lazy: withNamespaces(['bubble'], async () => {
            const { TaskEdit } = await import('@/pages/bubble/tasks/edit')

            return { Component: TaskEdit }
          }),
        },
      ],
    },
  ],
}
